import { FC } from 'react'

import { ComponentTeamMembers } from 'api'
import { Team } from 'components/team-members'

interface Props {
  className?: string
  data: ComponentTeamMembers
}

export const TeamMembers: FC<Props> = ({
  className,
  data: { team_people, description, heading, pre_heading },
}) => {
  return (
    <Team
      people={team_people}
      subtitle={pre_heading}
      title={heading}
      linkTarget="__blank"
      content={description}
      className={className}
    />
  )
}
